/**
 * Customer Intent Step
 *
 * First step in the redesigned flow - determines what the customer wants to do
 * and routes them to the appropriate flow path.
 */

import { useFormContext } from 'react-hook-form';
import { IntentSelector } from '../../../components/order/IntentSelector';
import type { OrderForm } from '../../../schemas/order.schema';

interface CustomerIntentStepProps {
  onIntentSelected?: () => void;
}

export function CustomerIntentStep({ onIntentSelected }: CustomerIntentStepProps) {
  const { setValue, watch } = useFormContext<OrderForm>();

  // Watch the intent field
  const customerIntent = watch('customerIntent') || null;

  const handleIntentSelect = (intentId: string) => {
    setValue('customerIntent', intentId as 'new_delivery' | 'existing_container');

    // Set appropriate defaults based on intent
    if (intentId === 'new_delivery') {
      setValue('orderType', 'delivery');
    }
    // For existing_container, we'll determine orderType (swap/pickup) in a later step

    // Auto-advance to next step after selection
    if (onIntentSelected) {
      // Use setTimeout to ensure the form value is updated before advancing
      setTimeout(() => {
        onIntentSelected();
      }, 100);
    }
  };

  return (
    <IntentSelector
      selectedIntent={customerIntent}
      onSelect={handleIntentSelect}
    />
  );
}